import flatpickr from "flatpickr";
import queryString from 'query-string';
import "flatpickr/dist/themes/dark.css";
import { getOpeningTimes } from '../../api/index';

const createDatePicker = () => {

    const parsed = queryString.parse(location.search);

    if (parsed?.devID) {
        getOpeningTimes(parsed.devID).then((data) => {
            const openingTimesArr = data.data;

            let daysThatAreClosed = openingTimesArr.filter(item => {
                const opensAt = item.opening_times.opens_at;
                const closesAt = item.opening_times.closes_at;
                if (opensAt.length < 1 && closesAt.length < 1) {
                    return item.opening_times;
                }
             });

             let getClosetDaysValues = () => daysThatAreClosed.map(i => {
                return parseFloat(i.opening_times.day.value)
             });

             let daysArr = getClosetDaysValues();

             const datefield = ".datepicker input";

             const calendarOptions = {
                enableTime: true,
                dateFormat: "l j F Y H:i",
                minDate: new Date().fp_incr(1),
                "disable": [
                    function(date) {
                        return (date.getDay() === daysArr[0] || date.getDay() === daysArr[1] || date.getDay() === daysArr[2] || date.getDay() === daysArr[3] || date.getDay() === daysArr[4] || date.getDay() === daysArr[5] || date.getDay() === daysArr[6]);
                    }
                ],
                "locale": {
                    "firstDayOfWeek": 1
                },
                minTime: "09:00",
                maxTime: "17:00",
            }

            flatpickr(datefield, calendarOptions);

        });
    }
};

const DatePicker = () => createDatePicker();

export default DatePicker;